








import { computed, defineComponent } from '@nuxtjs/composition-api';

import SwiperNext from './SwiperNext.vue';
import SwiperPrev from './SwiperPrev.vue';

export default defineComponent({
  name: 'SwiperNavigation',
  components: {
    SwiperNext,
    SwiperPrev
  },
  props: {
    type: {
      required: true,
      type: String,
      default: 'prev',
      validator: (value: string) => ['next', 'prev'].includes(value)
    },
    title: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['navigation:click'],
  setup(props) {
    const componentMap = {
      next: 'SwiperNext',
      prev: 'SwiperPrev'
    };

    const component = computed<string>(() => {
      return componentMap[props.type] || componentMap.prev;
    });

    return {
      component
    };
  }
});
